module.exports = __webpack_public_path__ + "img/4bhk-h1.0e0e4708.jpg";